import { render } from "./YachtDocuments.vue?vue&type=template&id=31e2a096&scoped=true"
import script from "./YachtDocuments.vue?vue&type=script&lang=js"
export * from "./YachtDocuments.vue?vue&type=script&lang=js"

import "./YachtDocuments.vue?vue&type=style&index=0&id=31e2a096&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31e2a096"]])

export default __exports__